const config = {
    //活动票 状态
    signupStatusCode: {
        0: { des: '未签到' },
        1: { des: '已签到' },
        2: { des: '已取消' }
    },
    //活动报名订单 状态
    signupOrderListStatusCode: {
        0: {
            des: '待收费',
            color: '#FF8D09',
            operating: 'cancel'
        },
        1: { des: '已收费', color: '#27AF2D', QRCode: true },
        2: { des: '已报名', color: '#27AF2D', QRCode: true },
        3: { des: '已取消', color: '#B3B3B3', ori: '用户取消' },
        4: { des: '已取消', color: '#B3B3B3', ori: '系统取消' },
        5: {
            value: '待退款',
            color: '#FF8D09'
        },
        6: { des: '已退款', color: '#27AF2D' },
        7: { des: '锁定', color: '#446BFF' },
        8: { des: '已完成', color: '#27AF2D', QRCode: true }
    },

    //门票状态
    ticketStatusCode: {
        0: { des: '待付款', color: '#FF8D09' },
        1: { des: '待取票', color: '#27AF2D' },
        2: { des: '待检票', color: '#446BFF' },
        3: { des: '已退票' },
        4: { des: '已检票', color: '#446BFF' },
        5: { des: '已过期' },
        6: { des: '自动核销' }
    },
    //门票订单
    ticketOrderListStatusCode: {
        0: { des: '等待付款', color: '#FF8D09' },
        1: { des: '已付款', color: '#27AF2D', QRCode: true },
        3: { des: '已出票', color: '#27AF2D', QRCode: true },
        4: { des: '部分取票', color: '#446BFF', QRCode: true },
        5: { des: '已取票', color: '#27AF2D', QRCode: true },
        6: { des: '已取消', color: '#B3B3B3', ori: '顾客取消订单' },
        7: { des: '已取消', color: '#B3B3B3', ori: '商家取消订单' },
        8: { des: '已取消', color: '#B3B3B3', ori: '系统自动取消订单' },
        9: { des: '等待退款', color: '#FF8D09' },
        10: { des: '已退款', color: '#27AF2D' },
        11: { des: '锁定', color: '#446BFF' },
        12: { des: '已完成', color: '#27AF2D', QRCode: true }
    },
}
export default config;